import apiClient from './apiClient'
export {
  queryProjectDetail,
  latestNews,
  getProjectEvaluateList,
  searchProjectList,
  getClassicalProject,
  getCompanyCaseShareCard,
  searchProjectListByCompanyId
}
async function queryProjectDetail(params) {
  const res = await apiClient.get('queryProjectDetail.do', {
    params: { ...params, product: 'owner' }
  })
  return res.data
}

async function latestNews(param) {
  // const params = new URLSearchParams()
  // params.append('isDisplay', '1')
  // params.append('isDisplay', '3')
  // params.append('pageNo', param.pageNo)
  // params.append('pageSize', param.pageSize)
  // params.append('projectId', param.projectId)
  const res = await apiClient.post('v3/latestNews/list.do', { ...param })
  return res.data
}

async function getProjectEvaluateList(params) {
  const res = await apiClient.get('getProjectEvaluateList.do', {
    params: { ...params, product: 'owner' }
  })
  return res.data
}

async function searchProjectList(params) {
  const res = await apiClient.get('searchProjectList.do', { params })
  return res.data
}

async function getClassicalProject({
  caseType = 3,
  companyId,
  pageNo = 1,
  pageSize = 40,
  isShow = 'Y'
}) {
  const res = await apiClient.get('getClassicalProject.do', {
    params: {
      caseType,
      companyId,
      pageNo,
      pageSize,
      isShow
    }
  })

  return res.data
}

async function getCompanyCaseShareCard(params) {
  const res = await apiClient.get('getCompanyCaseShareCard.do', {
    params
  })
  return res.data.data
}

async function searchProjectListByCompanyId(params) {
  const res = await apiClient.get('searchProjectListByCompanyId.do', {
    params
  })
  return res.data.data
}

export async function getStageTemplateList(companyId) {
  const res = await apiClient.get('/getStageTemplateList.do', {
    params: { companyId }
  })
  return res.data
}

export async function getStageTemplate(params) {
  const res = await apiClient.get('/getStageTemplate.do', {
    params
  })
  return res.data
}
// 各阶段工地数分布
export async function getStageProjectDistribution({
  companyId,
  stageTemplateId,
  day
}) {
  const res = await apiClient.post('/statistics/stage/distributed', {
    companyId,
    stageTemplateId,
    day
  })
  return res.data
}
